/**
 * EmptyState — centered icon + copy for empty lists / zero-data panels.
 */
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  body?: ReactNode;
  /** Optional call-to-action node (e.g. a Button or Link). */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div className={cn('py-8 text-center', className)}>
      <Icon className="mx-auto mb-2 h-8 w-8 text-faint opacity-40" />
      <p className="text-sm font-medium">{title}</p>
      {body && <p className="text-sm text-faint">{body}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
